import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useState, useEffect, useRef } from "react";
import { withProps, withHandlers, compose } from "recompose";
import classNames from "classnames";
import { noop, get, toInteger } from "lodash";
import { Button, Classes } from "@blueprintjs/core";
import { onEnterOrBlurHelper } from "../utils/handlerHelpers";
import { defaultPageSizes } from "./utils/queryParams";
import getIdOrCodeOrIndex from "./utils/getIdOrCodeOrIndex";

function PagingInput(_ref) {
  var disabled = _ref.disabled,
      onBlur = _ref.onBlur,
      defaultPage = _ref.defaultPage;

  var _useState = useState(defaultPage),
      page = _useState[0],
      setPage = _useState[1];

  var defaultValue = useRef(defaultPage);
  useEffect(function () {
    if (page !== defaultPage && defaultValue.current !== defaultPage) {
      setPage(defaultPage);
    }

    defaultValue.current = defaultPage;
  }, [page, defaultPage]);
  return /*#__PURE__*/React.createElement("input", _extends({
    style: {
      marginLeft: 5,
      width: 35,
      marginRight: 8
    },
    value: page,
    disabled: disabled,
    onChange: function onChange(e) {
      setPage(e.target.value);
    }
  }, onEnterOrBlurHelper(onBlur), {
    className: Classes.INPUT
  }));
}

var PagingTool = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(PagingTool, _React$Component);

  function PagingTool() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      refetching: false
    });

    _defineProperty(_assertThisInitialized(_this), "onRefresh", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.setState({
                refetching: true
              });

              _context.next = 3;
              return _this.props.onRefresh();

            case 3:
              _this.setState({
                refetching: false
              });

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "setPage", function (page) {
      _this.props.setPage(page);

      _this.props.onPageChange(page);
    });

    _defineProperty(_assertThisInitialized(_this), "setPageSize", function (e) {
      var _this$props = _this.props,
          setPageSize = _this$props.setPageSize,
          _this$props$persistPa = _this$props.persistPageSize,
          persistPageSize = _this$props$persistPa === void 0 ? noop : _this$props$persistPa;
      var pageSize = parseInt(e.target.value, 10);
      setPageSize(pageSize);
      persistPageSize(pageSize);
    });

    _defineProperty(_assertThisInitialized(_this), "pageBack", function () {
      var page = _this.props.paging.page;

      _this.setPage(parseInt(page, 10) - 1);
    });

    _defineProperty(_assertThisInitialized(_this), "pageForward", function () {
      var page = _this.props.paging.page;

      _this.setPage(parseInt(page, 10) + 1);
    });

    _defineProperty(_assertThisInitialized(_this), "pageInputBlur", function (e) {
      var _this$props$paging = _this.props.paging,
          pageSize = _this$props$paging.pageSize,
          total = _this$props$paging.total;
      var lastPage = Math.ceil(total / pageSize);
      var pageValue = parseInt(e.target.value, 10);
      var selectedPage = pageValue > lastPage ? lastPage : pageValue < 1 || isNaN(pageValue) ? 1 : pageValue;

      _this.setState({
        selectedPage: selectedPage
      });

      _this.setPage(selectedPage);
    });

    return _this;
  }

  var _proto = PagingTool.prototype;

  _proto.componentDidMount = function componentDidMount() {
    //set a
    var additionalPageSize = window.frontEndConfig && window.frontEndConfig.additionalPageSize ? [toInteger(window.frontEndConfig.additionalPageSize)] : [];
    window.tgPageSizes = [].concat(defaultPageSizes, additionalPageSize);
  };

  _proto.render = function render() {
    var refetching = this.state.refetching;
    var _this$props2 = this.props,
        _this$props2$paging = _this$props2.paging,
        pageSize = _this$props2$paging.pageSize,
        page = _this$props2$paging.page,
        total = _this$props2$paging.total,
        onRefresh = _this$props2.onRefresh,
        hideTotalPages = _this$props2.hideTotalPages,
        disabled = _this$props2.disabled,
        controlled_hasNextPage = _this$props2.controlled_hasNextPage,
        disableSetPageSize = _this$props2.disableSetPageSize,
        hideSetPageSize = _this$props2.hideSetPageSize;
    var pageStart = (page - 1) * pageSize + 1;
    if (pageStart < 0) throw new Error("We should never have page be <0");
    var backEnabled = page - 1 > 0;
    var forwardEnabled = page * pageSize < total;
    var lastPage = Math.ceil(total / pageSize);
    var options = [].concat(window.tgPageSizes || defaultPageSizes);

    if (!options.includes(pageSize)) {
      options.push(pageSize);
    }

    return /*#__PURE__*/React.createElement("div", {
      className: "paging-toolbar-container"
    }, onRefresh && /*#__PURE__*/React.createElement(Button, {
      minimal: true,
      loading: refetching,
      icon: "refresh",
      disabled: disabled,
      onClick: this.onRefresh
    }), !hideSetPageSize && /*#__PURE__*/React.createElement("div", {
      title: "Set Page Size",
      className: classNames(Classes.SELECT, Classes.MINIMAL)
    }, /*#__PURE__*/React.createElement("select", {
      className: "paging-page-size",
      onChange: this.setPageSize,
      disabled: disabled || disableSetPageSize,
      value: pageSize
    }, [/*#__PURE__*/React.createElement("option", {
      key: "page-size-placeholder",
      disabled: true,
      value: "fake"
    }, "Size")].concat(options.map(function (size) {
      return /*#__PURE__*/React.createElement("option", {
        key: size,
        value: size
      }, size);
    })))), /*#__PURE__*/React.createElement(Button, {
      onClick: this.pageBack,
      disabled: !backEnabled || disabled,
      minimal: true,
      className: "paging-arrow-left",
      icon: "chevron-left"
    }), /*#__PURE__*/React.createElement("div", null, hideTotalPages ? page : total ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PagingInput, {
      disabled: disabled,
      onBlur: this.pageInputBlur,
      defaultPage: page
    }), "of ", lastPage) : "No Rows"), /*#__PURE__*/React.createElement(Button, {
      style: {
        marginLeft: 5
      },
      disabled: (controlled_hasNextPage === undefined ? !forwardEnabled : !controlled_hasNextPage) || disabled,
      icon: "chevron-right",
      minimal: true,
      className: "paging-arrow-right",
      onClick: this.pageForward
    }));
  };

  return PagingTool;
}(React.Component);

_defineProperty(PagingTool, "defaultProps", {
  onPageChange: noop
});

export default compose(withProps(function (props) {
  var entityCount = props.entityCount,
      page = props.page,
      pageSize = props.pageSize,
      disabled = props.disabled,
      pagingDisabled = props.pagingDisabled,
      onRefresh = props.onRefresh,
      controlled_setPage = props.controlled_setPage,
      controlled_setPageSize = props.controlled_setPageSize,
      controlled_page = props.controlled_page,
      controlled_total = props.controlled_total,
      controlled_onRefresh = props.controlled_onRefresh,
      setPage = props.setPage,
      setPageSize = props.setPageSize;
  return {
    paging: {
      total: controlled_total || entityCount,
      page: controlled_page || page,
      pageSize: pageSize
    },
    disabled: disabled || pagingDisabled,
    onRefresh: controlled_onRefresh || onRefresh,
    setPage: controlled_setPage || setPage,
    setPageSize: controlled_setPageSize || setPageSize
  };
}), withHandlers({
  onPageChange: function onPageChange(_ref3) {
    var entities = _ref3.entities,
        keepSelectionOnPageChange = _ref3.keepSelectionOnPageChange,
        change = _ref3.change;
    return function () {
      var record = get(entities, "[0]");

      if (!keepSelectionOnPageChange && (!record || !getIdOrCodeOrIndex(record))) {
        change("reduxFormSelectedEntityIdMap", {});
      }
    };
  }
}))(PagingTool);